<template>
  <div id="app">
    <router-view></router-view>  <!-- Affiche le composant de la route courante -->
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>
